import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Lock } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { shelfItemShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import './PrivacyIndicator.scss';

export default function PrivacyIndicator({ author, shelfItem }) {
  return author.get('loggedIn') && shelfItem?.get('privateItem') ? (
    <span className="cp-privacy-indicator">
      <Lock />
      <span className="private-label" aria-hidden>
        <FormattedMessage id="private" />
      </span>
      <ScreenReaderMessage>
        <FormattedMessage id="private_ugc_sr_message" />
      </ScreenReaderMessage>
    </span>
  ) : null;
}

PrivacyIndicator.propTypes = {
  author: userIdentityShape.isRequired,
  shelfItem: shelfItemShape
};
